import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { checkPromocode, checkPromocodeSeparatly } from '../redux/actions/basket';
import { deleteBasketItem } from '../redux/reducers/basketReducer';
import { Card } from '../components/card';

import { clearError } from '../redux/reducers/commonReducer';
import messages from '../constants/messages';
import { LoaderSpinner } from '../components/loaderAndSpinners';
import collectProductVariants from '../helpers/collectProductVariants';

class Basket extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      deliverError: false,
      promoCode: '',
      massDeliverPrice: [],
      shippingCountry: '',
      shippingType: {},
      showLoader: false,
      showAnswer: '',
      pricesLoading: false,

      name: '',
      country: '',
      city: '',
      street: '',
      house: '',
      apartment: '',
      email: '',
      tel: '',
      index: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.deleteFotobook = this.deleteFotobook.bind(this);
    this.takeAllPrice = this.takeAllPrice.bind(this);
    this.getExactPrice = this.getExactPrice.bind(this);
    this.checkPromocode = this.checkPromocode.bind(this);
    this.closeLoader = this.closeLoader.bind(this);
    this.payFunction = this.payFunction.bind(this);
  }

  componentDidMount() {
    this.props.clearError();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  // eslint-disable-next-line react/sort-comp
  deleteFotobook(e, item) {
    const massBasket = this.props.basket;
    this.props.deleteBasketItem(item);
    const mass = massBasket.filter(book => book.id !== item.id);
    const basket = mass;
    if (basket.length === 0) return;
    const { product_variants, accomp_products } = collectProductVariants(basket);
    const req = {
      product_variants,
      accomp_products,
    };
    this.takeAllPrice(req);
  }

  async checkPromocode(val) {
    this.setState({ showLoader: true });
    const answ = await this.props.checkPromocodeSeparatly(this.state.promoCode);
    this.setState({ showLoader: false });
    if (answ.errorMessage) {
      this.setState({ showAnswer: messages.promoError });
    } else {
      const resp = await this.takeAllPrice(val);
      if (resp.errorMessage) {
        this.setState({ showAnswer: messages.promoError });
      } else {
        this.setState({
          showAnswer: messages.checkPromocode,
          promoDiscount: resp,
        });
      }
    }
  }

  async getExactPrice(req) {
    const res = await this.props.checkPromocode(req);
    if (res.errorMessage) {
      this.setState({ showAnswer: res.promoError });
      return res;
    }
    res.id = req.shipping_type_id;

    const massDeliverPrice = this.state.massDeliverPrice.find(item => item.id === res.id)
      ? this.state.massDeliverPrice.map(item => (item.id === res.id ? res : item))
      : [...this.state.massDeliverPrice, res];
    this.setState({ massDeliverPrice });
  }

  async takeAllPrice(req) {
    const massID = [];
    this.props.delivery.forEach(item => {
      if (item.items?.[this.state.shippingCountry]?.items) {
        item.items?.[this.state.shippingCountry]?.items.map(elem => {
          massID.push(elem.serverId);
          return elem;
        });
      } else {
        massID.push(item.id);
      }
    });
    const { length } = massID;
    const newMassPrice = [];
    const templateReq = req;
    this.setState({ pricesLoading: true });
    for (let i = 0; i < 3; i += 1) {
      templateReq.shipping_type_id = massID[i];
      const res = await this.props.checkPromocode(templateReq);

      if (res.errorMessage) {
        this.setState({ showAnswer: res.promoError });
        return res;
      }
      res.id = massID[i];
      newMassPrice.push(res);
    }

    this.setState({ massDeliverPrice: newMassPrice, pricesLoading: false }, () => {
      const { shippingType } = this.state;
      if (shippingType.id) {
        this.getExactPrice({ ...templateReq, shipping_type_id: shippingType.child || shippingType.id });
      }
    });
    return { status: true };
  }

  closeLoader() {
    this.setState({
      showAnswer: '',
      showLoader: false,
      showLineLoader: false,
    });
  }

  payFunction() {
    const { name, country, city, street, house, email, tel, apartment, index, promoCode, shippingType } = this.state;
    if (!name || !country || !city || !street || !house || !email || !tel) {
      this.setState({ error: true });
      const topPos = document.querySelector('.card-form-title').offsetTop;
      window.scrollTo(0, topPos - 30);
      return;
    }
    if (!shippingType.id || (shippingType.id === 'courier_cities' && !shippingType.child)) {
      this.setState({ showLoader: true, showAnswer: messages.notCurier, deliverError: true });
      const topPos = document.querySelector('.divider').offsetTop;
      window.scrollTo(0, topPos - 30);
      return;
    }
    const userInfo = { name, country, city, street, house, apartment, email, tel, index, promoCode, shippingType };
    this.props.payFunction(userInfo);
  }

  render() {
    const { basket, delivery } = this.props;
    const { name, country, city, street, house, apartment, email, tel, index } = this.state;
    const formObj = { name, country, city, street, house, apartment, email, tel, index };

    return (
      <div>
        <LoaderSpinner
          showLoader={this.state.showLoader}
          showAnswer={this.state.showAnswer}
          closeLoader={this.closeLoader}
        />
        <Card
          loading={this.state.pricesLoading}
          handleChange={this.handleChange}
          basket={basket}
          formObj={formObj}
          error={this.state.error}
          deliverError={this.state.deliverError}
          promoCode={this.state.promoCode}
          delivery={delivery}
          takeAllPrice={this.takeAllPrice}
          getExactPrice={this.getExactPrice}
          deleteFotobook={this.deleteFotobook}
          checkPromocode={this.checkPromocode}
          massDeliverPrice={this.state.massDeliverPrice}
          payFunction={this.payFunction}
          shippingType={this.state.shippingType}
          shippingCountry={this.state.shippingCountry}
        />
      </div>
    );
  }
}

const mapStateToProps = reduxState => ({
  delivery: reduxState.basket.delivery,
  basket: reduxState.basket.basket,
});

const Basket_Redux = connect(mapStateToProps, {
  deleteBasketItem,

  checkPromocode,
  checkPromocodeSeparatly,
  clearError,
})(Basket);

export default withRouter(Basket_Redux);
